import BaseAPI from '@/apis/base/baseApi';
export default class SAApi extends BaseAPI {
  apiName = 'SA';
}
